import React from 'react';
import { useContainer } from 'unstated-next';
import ClassContainer from '../../ClassContainer';
import UnauthorizedUserAccessView from '../../../AdminSettings/SettingsPanels/UnauthorizedUserAccessView';

const UnauthorizedUserAccessClassSetting: React.FC = () => {
    const { watch, setValue } = useContainer(ClassContainer);

    const setting = watch('unauthorizedUserAccess');
    const text = watch('unauthorizedUserText');

    const setSetting = (newSetting) => setValue('unauthorizedUserAccess', newSetting);
    const setText = (newText) => setValue('unauthorizedUserText', newText);

    return (
        <UnauthorizedUserAccessView
            setting={setting}
            setSetting={setSetting}
            text={text}
            setText={setText}
        />
    );
};

export default UnauthorizedUserAccessClassSetting;